<template>
    <pdf-view :src="src" :key="componentKey" @loaded="loaded"></pdf-view>
</template>

<script>
    import PdfView from './PdfView'

    export default {
        name: 'Pdfjs',
        props: {
            src: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                componentKey: 0
            }
        },
        components: { PdfView },
        watch: {
            src (newSrc, oldSrc) {
                if (newSrc !== oldSrc) {
                    this.componentKey += 1
                }
            }
        },
        methods: {
            loaded () {
                this.$emit('loaded')
            }
        }
    }
</script>
